import React, {useContext, useEffect, useState} from 'react'
import { isNeitherNullNorUndefined } from '../utils/functions'
import {lerneinheitenOverviewPageID, jwtName} from '../constants'
import Cookies from 'universal-cookie';


export const PageTreeContext = React.createContext()



function PageTreeContextProvider(props){
    const [pageTree, setPageTree] = useState()
    const [currentPageID, setCurrentPageID] = useState()
    const [pageNavigationInfo, setPageNavigationInfo] = useState()
    const [isBreadcrumbsVisible, setIsBreadcrumbsVisible] = useState(false)
    const [loggedIn, setLoggedIn] = useState(false)
    const cookies = new Cookies()

    function changeIsBreadcrumbsVisible(bool){
        setIsBreadcrumbsVisible(bool);
    }

    function forceLogout(){
        setLoggedIn(false)
    }

    function amILoggedIn(){
        const jwt = cookies.get(jwtName)     
        if(isNeitherNullNorUndefined(jwt)){
            setLoggedIn(true)
            return true
        } else {
            setLoggedIn(false)
            return false
        }
    }

    function checkLocalStorageForPageTree(){
        try {
              const localStoredPageTree = JSON.parse(localStorage.getItem('pageTree_prof'))
                if(localStoredPageTree !== pageTree){
                    return(localStoredPageTree)
                }
            } catch (error) {
                console.log(error)
            }
    }

    useEffect(() => {
        // retrieve pageTree from local storage after url change
        //TODO: why is it lost from context???
        function checkPageTreeHelper(){
            const localPageTree = checkLocalStorageForPageTree()
            if(isNeitherNullNorUndefined(localPageTree)){
                setPageTree(localPageTree)
            }
        }
        if(typeof pageTree === "undefined"){
            checkPageTreeHelper()
        } 
      }, [pageTree])


    function getPageTree(){
        if(isNeitherNullNorUndefined(pageTree)){
            return pageTree
        } else {
            const localPageTree = checkLocalStorageForPageTree()
            if(isNeitherNullNorUndefined(localPageTree)){
                return localPageTree
            } else {
                console.log("error in getPageTree()")
                return null
            }
        }
    }


    function initalizePageTree(pageTree){
        setPageTree(pageTree)
        // additionally save to local storage because constext gets lost on url change/refresh for some reason
        localStorage.setItem('pageTree_prof', JSON.stringify(pageTree))
        if(isNeitherNullNorUndefined(currentPageID)){
            const newPageNavigationInfo = createPageNavigationInfo(currentPageID)          // TODO move creation to backend, receive here
            setPageNavigationInfo(newPageNavigationInfo)
        } 
    }


    function getPageNavigationInfo(currentPageID_unparsed){
        // TODO: pageTree is null when navigate directly to page url !!!
        // retrieve pageTree from localstorage if not in context
        if(typeof pageTree === "undefined" || pageTree === null){
            const localPageTree = checkLocalStorageForPageTree()
        }
        if(isNeitherNullNorUndefined(currentPageID_unparsed)){
           if(pageNavigationInfo == null || typeof pageNavigationInfo === "undefined" || pageNavigationInfo?.lerneinheitID === null){
                const newPageNavigationInfo = createPageNavigationInfo(currentPageID_unparsed)          // move creation to backend, receive here
                setPageNavigationInfo(newPageNavigationInfo)
                return newPageNavigationInfo
            } else {
                if(parseInt(currentPageID_unparsed) === currentPageID){
                    return pageNavigationInfo
                } else {
                    const newPageNavigationInfo = createPageNavigationInfo(currentPageID_unparsed)          // move creation to backend, receive here
                    setPageNavigationInfo(newPageNavigationInfo)
                    return newPageNavigationInfo
                }
            } 
        } else {
            console.log("ERROR", "currentPageID_unparsed is undefined")
        }
    }


    //TODO: completely redo navigation algorithm!!!
    function createPageNavigationInfo(currentPageID_unparsed){
        // workaround because pageTree disappears from context. Retrieve from localStorage if not available
        let pageTreeToWorkWith = null
        if(typeof pageTree === "undefined" || pageTree === null){
            pageTreeToWorkWith = checkLocalStorageForPageTree()
        //    localPageTree && setPageTree(localPageTree)
        } else {
            pageTreeToWorkWith = pageTree
        }
        if(isNeitherNullNorUndefined(currentPageID_unparsed)){
            const currentPageID = parseInt(currentPageID_unparsed)
            if(typeof currentPageID){
                setCurrentPageID(currentPageID)
                let lerneinheitID = null
                let lerneinheitName = null
                let subChapterID = null
                let subChapterName = null
                let leafPageName = null
                let nextPageID = null   // can be leafPage or subChapter starting page
                let previousPageID = null
                let isExercisePage = false
                let category = null
                // pageTree is null
                if(isNeitherNullNorUndefined(pageTreeToWorkWith)){
                    pageTreeToWorkWith.forEach((lerneinheit, index) => {
                        //TODO: breaking points if chapter/leafPage found to avoid unnecessary iterations
                        if(lerneinheit.uid === currentPageID){
                            lerneinheitID = currentPageID
                            lerneinheitName = lerneinheit.title
                            nextPageID = lerneinheit.subChapters[0].uid
                            previousPageID = lerneinheitenOverviewPageID // TODO: for now....
                        } else {
                            lerneinheit.subChapters.forEach((subChapter, index) => {
                                if(subChapter.uid === currentPageID){  
                                    // is subChapterPage
                                    lerneinheitID = lerneinheit.uid
                                    lerneinheitName = lerneinheit.title
                                    subChapterID = subChapter.uid
                                    subChapterName = subChapter.title
                                    nextPageID = subChapter.leafPages[0].uid
                                    previousPageID = lerneinheitID      //TODO: last leafPage of previous subChapter?
                                } else {
                                    // iterate over subChapter's leafPages
                                    subChapter.leafPages.forEach((leafPage, index) => {
                                        if(leafPage.uid === currentPageID && leafPage.pid === subChapter.uid){
                                            // isExercisePage information already stored in pageTreeToWorkWith
                                            isExercisePage = leafPage.isExercisePage
                                            // add category info if exists
                                            category = leafPage.category
                                            //  found LE -> subChapter -> leafPage
                                            lerneinheitID = lerneinheit.uid
                                            lerneinheitName = lerneinheit.title
                                            subChapterID = subChapter.uid
                                            subChapterName = subChapter.title
                                            leafPageName = leafPage.title
                                            // get next leafPage ID
                                            const leafPageIDsOfSubChapter = subChapter.leafPages.map(leafPageObject => {
                                                return leafPageObject.uid
                                            })
                                            const positionOfLeafPage = leafPageIDsOfSubChapter.indexOf(currentPageID)
                                            // get next and previous pageIDs
                                            const subChapterPosition = lerneinheit.subChapters.map(sc => {
                                                return sc.uid
                                            }).indexOf(subChapterID)
                                            if(positionOfLeafPage < leafPageIDsOfSubChapter.length - 1){
                                                // is not last in subChapter
                                                nextPageID = leafPageIDsOfSubChapter[positionOfLeafPage + 1]
                                                // get previous
                                                if(positionOfLeafPage !== 0){
                                                    // is not first
                                                    previousPageID = leafPageIDsOfSubChapter[positionOfLeafPage - 1]
                                                } else {
                                                    // is first in subCHapter => previous = previous subChapter or previous Lerneinheit
                                                    if(subChapterPosition !== 0){
                                                        //TODO: For now just go to start of last subChapter
                                                        previousPageID = lerneinheit.subChapters[subChapterPosition - 1].uid
                                                    } else {
                                                        //TODO: For now just go to Lerneinheiten overvew page
                                                        previousPageID = lerneinheitenOverviewPageID
                                                    }
                                                }
                                            } else {
                                                // is last in subChapter => next page = next subChapter or next Lerneinheit
                                                previousPageID = leafPageIDsOfSubChapter[positionOfLeafPage - 1]
                                                if(subChapterPosition < lerneinheit.subChapters.length - 1){
                                                    // is not in last subChapter
                                                    nextPageID = lerneinheit.subChapters[subChapterPosition + 1].uid
                                                } else {
                                                    // is in last subChapter of Lerneinheit
                                                    //TODO: For now just go to Lerneinheiten, get actual next page = next Lerneinheit 
                                                    nextPageID = lerneinheitenOverviewPageID
                                                }
                                            }
                                        } else {
                                            // is lerneinheit starting page
                                            // condition checked first
                                        //   console.log("Unknown condition or is LE starting page")
                                        }
                                    })
                                }
                            })
                        }
                    });
                } else {
                    console.log("pageTreeToWorkWith IS NULL", pageTreeToWorkWith)
                }
                return {
                    lerneinheitID: lerneinheitID, 
                    lerneinheitName,
                    subChapterID: subChapterID, 
                    subChapterName,
                    leafPageName,
                    nextPageID: nextPageID == null ? lerneinheitenOverviewPageID : nextPageID,     
                    previousPageID: previousPageID == null ? lerneinheitenOverviewPageID : previousPageID,
                    isExercisePage: isExercisePage,
                    category: category

                }  
            } else {
                console.log("ERROR", "current page ID is NaN")
            }
        } else {
            console.log("ERROR in createPageNavigationInfo ", "currentPageID_unparsed is undefined")
        }
    }



    
    return (
        <PageTreeContext.Provider value={{
            pageTree,
            getPageTree,
            initalizePageTree,
            getPageNavigationInfo,
            currentPageID,
            pageNavigationInfo,
            isBreadcrumbsVisible,
            changeIsBreadcrumbsVisible,
            amILoggedIn,
            loggedIn,
            forceLogout
            }}>
            {props.children}
        </PageTreeContext.Provider>
    )
}
export default PageTreeContextProvider